export const LOGO_COLOR_RED = '#da4151';
export const LOGO_COLOR_GREEN = '#1f7251';
export const DARK_BLUE = '#233a68';
export const WHITE = '#fff';
